import routerOptions0 from "/vercel/path0/app/router.options.ts";
import routerOptions1 from "/vercel/path0/node_modules/nuxt/dist/pages/runtime/router.options";
const configRouterOptions = {}
export default {
...configRouterOptions,
...routerOptions1,
...routerOptions0,
}